<script>

	import Layout from '@layouts/main'
	import appConfig from '@src/app.config'
	import api from '@/odooapi'
	import rpc from '@/odoorpc'
	import or from 'vuelidate/lib/validators/or'



	/**
	 * Dashboard-1 Component
	 */
	export default {
		page: {
			title: '财务中心',
			meta: [{
				name: 'description',
				content: appConfig.description
			}],
		},
		components: {
			Layout,
		},
		data() {
			return {
				 // 显示搜索条件
      			showSearch: true,
				queryParams:{
					order_name:undefined,
					client_order_ref:undefined,
					product_tmpl_name:undefined,
				},
				// 数据列表
				salesList:[],
				// 分页信息
				paginationData:{
					// 总数据条数
					total:0,
					// 当前页
					currentPage:1,
					// 每页展示几条数据
					page_Size:10,
				},
			}
		},
		created(){
			this.getData()
		},
		methods:{
			getData(){
				rpc.web.dataset.call_kw({
					model:'sale.order.productions',
					method:'search_sale_order_productions_finance',
					args:[],
					kwargs:{
						"currentPage":this.paginationData.currentPage,
						"pageSize":this.paginationData.page_Size,
						"order_name":this.queryParams.order_name,
						"client_order_ref":this.queryParams.client_order_ref,
						"product_tmpl_name":this.queryParams.product_tmpl_name
					}
				})
				.then(res=>{
					this.salesList = res.data
					this.paginationData.total = res.total
					
				})
				
			},
			// 搜索按钮
			handleQuery(){
				if(!this.queryParams.order_name || !this.queryParams.product_tmpl_name){
					this.paginationData.currentPage = 1
					
				}
				this.getData()
			},
			// 重置按钮
			resetQuery(){
				this.queryParams.order_name = ""
				this.queryParams.client_order_ref = ""
				this.queryParams.product_tmpl_name = ""
				this.paginationData.currentPage = 1
				this.getData()
			},
			// 分页
			handlePageSize(page_size){
				this.paginationData.page_Size=page_size
				// 这里写获取的的方法
      			this.getData()
			},
			handlePageChange(pageNum){
				this.paginationData.currentPage=pageNum
				// 这里写获取的的方法
				this.getData()
			}
		}
	}
</script>

<template>
	<Layout>
		<div class="row page-title align-items-center">
			<div class="col-sm-4 col-xl-6">
				<h4 class="mb-1 mt-0">财务中心</h4>
			</div>
			<div class="col-sm-8 col-xl-6">
				<form class="form-inline float-sm-right mt-3 mt-sm-0">
					<!-- <div class="form-group mb-sm-0 mr-2">
						<flat-pickr v-model="selectedDate" class="form-control" :config="dateConfig" name="date">
						</flat-pickr>
					</div> -->
					<div class="btn-group">
						<!-- <b-dropdown variant="primary" right>
							<template v-slot:button-content>
								<i class="uil uil-file-alt mr-1"></i>Download
								<i class="icon">
									<feather type="chevron-down" class="align-middle"></feather>
								</i>
							</template>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="mail" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Email</span>
							</b-dropdown-item>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="printer" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Print</span>
							</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="file" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Re-Generate</span>
							</b-dropdown-item>
						</b-dropdown> -->
					</div>
				</form>
			</div>
		</div>

    <div class="row">
      <div class="col">
		<div class="card">
			<div class="card-body p-0">
				<el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="p-3">
					<el-form-item label="客户订单编号" prop="roleName">
						<el-input v-model="queryParams.client_order_ref" placeholder="请输入客户订单编号" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item>
					<el-form-item label="规格型号" prop="roleKey">
						<el-input v-model="queryParams.product_tmpl_name" placeholder="请输入规格型号" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
						</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>

				<div style="margin-top: -0.6rem;">
					<el-table :data="salesList" style="width: 100%" class="p-3">
						<el-table-column type="selection" width="55" align="center"/>
						<!-- <el-table-column prop="partner_name" label="客户"/> -->
						<el-table-column prop="order_name" label="订单编号"/>
						<el-table-column prop="client_order_ref" label="客户订单编号"/>
						<el-table-column prop="order_type" label="订单类型"/>
						<el-table-column prop="product_cat" label="订单名称"/>
						<el-table-column prop="product_tmpl_name" label="规格型号"/>
						<el-table-column prop="price_state" label="价格状态"/>
						<el-table-column prop="reconciliation_state" label="对账状态"/>
						<el-table-column prop="payment_state" label="收款状态"/>
						<el-table-column prop="invoice_state" label="开票状态"/>

						<!-- <el-table-column label="查看明细">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" @click="info(scope.row.order_id)">核料详情</el-button>
						</template>
						</el-table-column> -->

					</el-table>
				</div>

				<el-pagination
					background
					style="margin-top: 20px; text-align: right;"
					layout="total, sizes, prev, pager, next, jumper"
					:total="paginationData.total"
					:current-page="paginationData.currentPage"
					:page-size="paginationData.page_Size"
					:page-sizes="[10, 30, 50]"
					@size-change="handlePageSize"
					@current-change="handlePageChange"
					>
				</el-pagination>

			</div>
		</div>
	  </div>
    </div>

	</Layout>
</template>
